/**
 * 调性档 chip 组(2026-09-24,视频仓 0924 车 C)—— 幕一目的流「时长/比例」卡的第三列。
 *
 * 三档:带货喊话 / 品牌克制 / 高奢静默。默认值按租户行业推(`model/toneRegister.ts`,与 ai 同表);
 * 用户点过任意一颗 → `toneRegisterTouched=true`,之后不再跟行业。
 * `form.toneRegister` 始终存「当前生效的档」(默认值由页面 effect 写入),提交/编排/拍法卡都读它。
 */
import type { Dispatch, SetStateAction } from "react";

import type { FormState } from "../../model/videoCreateTypes";
import { TONE_REGISTER_OPTIONS, type ToneRegister } from "../../model/toneRegister";

import { OptionChip, OptionChipGroup } from "./OptionChip";

interface Props {
  form: FormState;
  setForm: Dispatch<SetStateAction<FormState>>;
  /** 当前生效的档(页面算好传入:点过用用户的,否则跟行业)。 */
  value: ToneRegister;
  disabled?: boolean;
}

export function VideoToneRegisterChips({ setForm, value, disabled }: Props) {
  const current = TONE_REGISTER_OPTIONS.find((o) => o.value === value);
  return (
    <div data-video-tone-register>
      <span className="mb-1.5 block text-sm text-muted-foreground">调性</span>
      <OptionChipGroup label="视频调性">
        {TONE_REGISTER_OPTIONS.map((o) => {
          const active = value === o.value;
          return (
            <OptionChip
              key={o.value}
              radio
              active={active}
              tabIndex={active ? 0 : -1}
              disabled={disabled}
              title={o.hint}
              data-testid={`tone-register-${o.value}`}
              onClick={() =>
                setForm((f) => ({ ...f, toneRegister: o.value, toneRegisterTouched: true }))
              }
            >
              {o.label}
            </OptionChip>
          );
        })}
      </OptionChipGroup>
      {current && (
        <p className="mt-1.5 max-w-[22rem] text-2xs leading-snug text-muted-foreground/80">
          {current.hint}
        </p>
      )}
    </div>
  );
}
